import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import componentStyle from '../common/styles/Component.css'
import style from './NotificationGroup.css'

/**
 * Notification group is used to position and style a group of notifications.
 *
 * @status ready
 * @category feedback
 * @slot - Default slot in which to place notifications.
 *
 * @fires {NordEvent} dismiss - Fired when a notification is dismissed, and its exit animation has completed. This event should be used to remove the dismissed notification from the DOM.
 *
 * @parent Notification
 */
@customElement('nord-notification-group')
export default class NotificationGroup extends LitElement {
  static styles = [componentStyle, style]

  render() {
    return html`
      <div class="n-notification-group">
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-notification-group': NotificationGroup
  }
}
